import { Dataset } from '../../types/types';
import { DATASET_ITEM_VISIBILITY_KEYS } from '../../constants';

// A string visibility key on a dataset item carries a JSONata expression
export const hasDynamicItemVisibility = (dataset: Dataset): boolean =>
  dataset.items?.some((item) =>
    DATASET_ITEM_VISIBILITY_KEYS.some((key) => typeof item[key] === 'string')
  ) ?? false;
